module.exports = __webpack_public_path__ + "assets/200395cf8ff4321ce0e9ecdd98579c00.png";